"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const constants_1 = require("../constants");
const OverflowWrapper = ({ children, className, }) => (react_1.default.createElement("div", { className: className, tabIndex: 0, "data-testid": constants_1.TestIds.overflow }, children));
const ResponsiveContainer = ({ containerLayoutClassName, overlowWrapperClassName, hasOverflow, shouldOmitWrapperLayers, children, role, extraRootClass = '', }) => {
    const wrapWithOverflowWrapperIfNeeded = (0, react_1.useCallback)((reactChildren) => !shouldOmitWrapperLayers && hasOverflow ? (react_1.default.createElement(OverflowWrapper, { className: (0, classnames_1.default)(overlowWrapperClassName, extraRootClass) }, reactChildren)) : (reactChildren), [
        extraRootClass,
        hasOverflow,
        overlowWrapperClassName,
        shouldOmitWrapperLayers,
    ]);
    return wrapWithOverflowWrapperIfNeeded(shouldOmitWrapperLayers ? (react_1.default.createElement(react_1.default.Fragment, null, children())) : (react_1.default.createElement("div", Object.assign({ className: hasOverflow
            ? containerLayoutClassName
            : (0, classnames_1.default)(containerLayoutClassName, extraRootClass), "data-testid": constants_1.TestIds.content }, (role ? { role } : {})), children())));
};
exports.default = ResponsiveContainer;
//# sourceMappingURL=ResponsiveContainer.js.map